module.exports = __webpack_public_path__ + "assets/study.822b05a0.svg";